import { render, staticRenderFns } from "./orderWeeklyItem.vue?vue&type=template&id=09679d53&scoped=true&"
import script from "./orderWeeklyItem.vue?vue&type=script&lang=js&"
export * from "./orderWeeklyItem.vue?vue&type=script&lang=js&"
import style0 from "./orderWeeklyItem.vue?vue&type=style&index=0&id=09679d53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09679d53",
  null
  
)

export default component.exports